// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contracts-list a:hover{background:#d3d3d3;text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/components/simulation/types/per/Details/Contracts.scss"],"names":[],"mappings":"AACE,wBACE,kBAAA,CACA,oBAAA","sourcesContent":[".contracts-list {\n  a:hover {\n    background: #d3d3d3;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
